export enum WaiverFee {
  ChangeFee = 1,
  FareDifference,
  NameChangeFee,
  RefundAvailable,
}
